import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export default function SectionHeader({ eyebrow, title, sub, center = false, light = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: EASE }}
      className={`mb-12 max-w-2xl ${center ? "mx-auto text-center" : ""}`}
    >
      <p
        className={`mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-bronze ${
          center ? "justify-center" : ""
        }`}
      >
        <span className="h-px w-10 bg-bronze" />
        {eyebrow}
      </p>
      <h2
        className={`font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl ${
          light ? "text-white" : "text-zinc-900 dark:text-white"
        }`}
      >
        {title}
      </h2>
      {sub && (
        <p className="mt-4 text-base leading-relaxed text-zinc-600 dark:text-zinc-400">{sub}</p>
      )}
    </motion.div>
  );
}
